// src/components/LoginButtons.jsx
import React, { useContext } from "react";
import { AuthContext } from "../context/AuthContext";

function LoginButtons() {
  const { login } = useContext(AuthContext);

  const googleLogin = () => {
    login({
      name: "Google User",
      method: "Google",
      email: "google@example.com"
    });
  };

  const appleLogin = () => {
    login({
      name: "Apple User",
      method: "Apple",
      email: "apple@example.com"
    });
  };

  const guestLogin = () => {
    login({
      name: "Guest",
      method: "Guest"
    });
  };

  return (
    <div className="login-btn-container">
      <button className="google-btn" onClick={googleLogin}>
        Continue with Google
      </button>

      <button className="apple-btn" onClick={appleLogin}>
        Continue with Apple
      </button>

      <button className="guest-btn" onClick={guestLogin}>
        Continue as Guest
      </button>
    </div>
  );
}

export default LoginButtons;
